import React, { useEffect, useState } from 'react';
import { SiteContent } from './admin/types';

interface NavigationProps {
  scrollToSection: (sectionId: string) => void;
}

const Navigation: React.FC<NavigationProps> = ({ scrollToSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [content, setContent] = useState<SiteContent['navigation']>({
    logoText: 'BBHA Insurance Services',
    menuItems: [
      { label: 'Home', id: 'hero' },
      { label: 'About', id: 'about' },
      { label: 'Our Team', id: 'agents' },
      { label: 'Company', id: 'about-us' }
    ]
  });

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const loadContent = async () => {
      try {
        const response = await fetch('/data/content.json');
        if (response.ok) {
          const data = await response.json();
          if (data.navigation) {
            setContent(data.navigation);
          }
        }
      } catch (error) {
        console.error('Error loading navigation content:', error);
      }
    };
    loadContent();
  }, []);

  const navItems = content.menuItems;

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/90 backdrop-blur-sm'
      }`}
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 lg:h-20 gap-4">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center">
            <img 
              src="/bhba-logo.png" 
              alt="BBHA Insurance Services company logo" 
              className="h-12 lg:h-16 w-auto mr-4"
              width="64"
              height="64"
            />
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-bbha-plum-800" aria-label="BBHA Insurance Services">{content.logoText}</div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block" role="menubar">
            <ul className="ml-6 lg:ml-8 flex items-baseline space-x-4 lg:space-x-6 list-none">
              {navItems.map((item) => (
                <li key={item.id} role="none">
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-gray-900 hover:text-bbha-olive-700 px-3 lg:px-4 py-2 rounded-md text-lg sm:text-xl lg:text-2xl font-medium transition-colors duration-200"
                    role="menuitem"
                    aria-label={`Navigate to ${item.label} section`}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
    </nav>
  );
};

export default Navigation;
